import { useStateSelector, useCooperativeId } from './';

export const useCurrentCooperative = () => {
  const coopId = useCooperativeId();
  const cooperatives = useStateSelector((state) => state.home.cooperatives);

  return cooperatives.find((coop) => coop.Id === coopId) || null;
};
